import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-date-view',
  template: `
    {{value | date:dateFormat }}
  `
})
export class DateViewComponent implements OnInit {

  dateFormat = 'dd-MM-yyyy';
  dateTimeFormat = 'dd-MM-yyyy HH:mm';

  @Input() value: string;
  @Input() format: string;
  @Input('with-time') withTime: boolean;

  constructor() {
  }

  ngOnInit() {
    if (this.withTime) {
      this.dateFormat = this.dateTimeFormat;
    }

    if (this.format && this.format.length > 0) {
      this.dateFormat = this.format;
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/forms/components/date-view/date-view.component.ts